let timeout = null;

const timeoutBuscaAutocomplete = (buscar, delay = 300) => {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    timeout = null;
    buscar();
  }, delay);
};

export default timeoutBuscaAutocomplete;
